import A from './types';
// account level {public:0, free:1, standard:2, premium:3, professional:4}
const initialState = {
  accountLevel: '',
  public: 0,
  free: 1,
  standard: 2,
  premium: 3,
  professional: 4,
  userInfo: {},
};

const reducer = (state, action) => {
  switch (action.type) {
    case A.ACCOUNT_UPDATE: {
      if (action.pending) {
        return {
          ...state,
          accountLevel: null,
          userInfo: {
            isLoading: false,
            loading: true,
            error: false,
            // data:{},
          },
        };
      }
      if (action.error) {
        return {
          ...state,
          accountLevel: null,
          userInfo: {
            isLoading: true,
            loading: false,
            error: action.payload.message,
            // data:{},
          },
        };
      }
      if (action.payload.message === 'success') {
        return {
          ...state,
          accountLevel: initialState[action.payload.data.memberPlan.toLowerCase()],
          userInfo: {
            isLoading: true,
            loading: false,
            error: false,
            data: action.payload.data,
          },
        };
      }
      return {
        ...state,
        accountLevel: null,
        userInfo: {
          isLoading: true,
          loading: false,
          error: action.payload.message,
          // data:{},
        },
      };
    }
    case A.ACCOUNT_INIT: {
      return {
        ...state,
        accountLevel: action.payload.accountLevel,
      };
    }
  }
  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/account/reducer.js